
let polyInst = null;
if (!window.i18n) {
    window.i18n = {
        languages: {},
        curLang: ''
    };
}

if (CC_EDITOR) {
    Editor.Profile.load('profile://project/i18n.json', (err, profile) => {
        if (err)
            cc.log("报错err:" + err);
        window.i18n.curLang = profile.data['default_language'];
        if (polyInst) {
            let data = loadLanguageData(window.i18n.curLang) || {};
            initPolyglot(data);
        }
    });
}

function loadLanguageData(language) {
    //Editor.log("loadLanguageData,window.i18n.curLang", language, window.i18n.curLang);
    if (!language) {
        if (window.i18n.curLang)

            return LoadCurrentLanguageData(window.i18n.curLang)
        else return;
    }
    //Editor.log(window.i18n.languages[language]);
    if (!window.i18n.languages[language]) {
        //cc.log("window.i18n.languages[language] 为空");
        const Fs = require('fs');
        const Path = require("path");
        let absolutePath = Path.join(Editor.Project.path, '/plugin-resource/json/' + "language" + '.json');
        var data = Fs.readFileSync(absolutePath);
        //Editor.log("window.i18n.languages[language]:",data);
        window.i18n.languages[language] = data;

    }
    return window.i18n.languages[language];
}
//新增读取
function LoadCurrentLanguageData(language) {
    // const Fs = require('fs');
    // const Path = require("path");
    // let absolutePath = Path.join(Editor.Project.path, '/assets/resources/i18n/' + "language" + '.json');
    // var data = Fs.readFileSync(absolutePath);
    // return data;
    if (!window.i18n.languages[language]) {
        const Fs = require('fs');
        const Path = require("path");
        let absolutePath = Path.join(Editor.Project.path, '/plugin-resource/json/' + "language" + '.json');
        var data = Fs.readFileSync(absolutePath);
        window.i18n.languages[language] = data;
    }
    return window.i18n.languages[language];
}
function initPolyglot(data) {
    //Editor.log("initPolyglot(data)",data);
    if (data) {
        //cc.log("data:" + data);
        if (polyInst) {
            polyInst = data;
        } else {
            //cc.log("polyInst 对象的初始话："+polyInst);
            polyInst = "";
            polyInst = data;
            //cc.log("初始化之后的polyInst："+polyInst);
        }
    }
}

module.exports = {
    /**
     * This method allow you to switch language during runtime, language argument should be the same as your data file name
     * such as when language is 'zh', it will load your 'zh.js' data source.
     * @method init
     * @param language - the language specific data file name, such as 'zh' to load 'zh.js'
     */
    init(language) {
        cc.log("初始化.ConfigLanguageData...init(language):" + language);


        if (language === window.i18n.curLang) {
            Editor.log("window.i18n.curLang", window.i18n.curLang);
            if (window.i18n.curLang) {
                const Fs = require('fs');
                const Path = require("path");
                let absolutePath = Path.join(Editor.Project.path, '/plugin-resource/json/' + "language" + '.json');
                var data = Fs.readFileSync(absolutePath);
                window.i18n.languages[window.i18n.curLang] = data;
                initPolyglot(data);
                this.inst = polyInst;
            }
            return;
        }
        if (!language) {
            Editor.Profile.load('profile://project/i18n.json', (err, profile) => {
                if (err)
                    cc.log("报错err:" + err);
                window.i18n.curLang = profile.data['default_language'];
                // Editor.log("设置window.i18n.curLang", window.i18n.curLang, profile.data['default_language']);
                // Editor.log("if (polyInst)",polyInst);
                if (polyInst) {
                    let data = loadLanguageData(window.i18n.curLang) || {};
                    initPolyglot(data);
                    this.inst = polyInst;
                }
                else {
                    let data = loadLanguageData(window.i18n.curLang) || {};
                    initPolyglot(data);
                    this.inst = polyInst;
                    polyInst = "";
                    polyInst = data;
                    return;
                }
            });
        }
        else {
            let data = loadLanguageData(language) || {};
            cc.log("init(language)", data);
            window.i18n.curLang = language;
            initPolyglot(data);
            this.inst = polyInst;
        }

    },

    containsKey(key) {
        // Editor.log("进入到containsKey");
        if (polyInst[0] === 0xEF && polyInst[1] === 0xBB && polyInst[2] === 0xBF) {
            polyInst = polyInst.slice(3);
        }
        polyInst = polyInst.toString('utf-8');

        var json = JSON.parse(polyInst)['public'];
        // cc.log("json", json);
        if (json.hasOwnProperty(key)) {
            // Editor.log("window.i18n.curLang", window.i18n.curLang);
            // Editor.log("json[key][window.i18n.curLang]", json[key][window.i18n.curLang]);
            if (json[key][window.i18n.curLang])
                return true;
            else return false;
        }
        else {
            Editor.log("return false");
            return false;
        }
    },
    parse(key) {
        //cc.log("调用 t 方法key:" + key);
        // cc.log("polyInst:"+polyInst);
        if (polyInst[0] === 0xEF && polyInst[1] === 0xBB && polyInst[2] === 0xBF) {
            polyInst = polyInst.slice(3);
        }
        polyInst = polyInst.toString('utf-8');
        // cc.log("polyInst文字化:"+polyInst);
        var json = JSON.parse(polyInst)["public"];
        //cc.log("parsekey", json)
        if (json.hasOwnProperty(key)) {
            cc.log(json[key]);
            return json[key][window.i18n.curLang].toString();
        }
        else return "";
    },
    inst: polyInst,
    //更新检测 检测场景中所有的ULabel
    updateSceneRenderers() { // very costly iterations
        //cc.log("ConfigLanguageData....updateSceneRenderers");
        let rootNodes = cc.director.getScene().children;
        // walk all nodes with localize label and update
        let allLocalizedLabels = [];
        for (let i = 0; i < rootNodes.length; ++i) {
            let labels = rootNodes[i].getComponentsInChildren('TLabel');
            Array.prototype.push.apply(allLocalizedLabels, labels);
        }
        // cc.log("更新000000000000000");
        // cc.log("更新检测 检测场景中所有的ULabel:"+allLocalizedLabels.length);
        for (let i = 0; i < allLocalizedLabels.length; ++i) {
            let label = allLocalizedLabels[i];
            // cc.log("!label.node.active:"+!label.node.active)
            // if (!label.node.active) continue;
            label.updateULabel();
        }
    }
};
